import React from 'react';
import WhatsAppMockup from '../components/WhatsAppMockup';
const WhatsAppPreview = () => {
  return <div className="w-full min-h-screen bg-slate-950 flex items-center justify-center p-8" data-id="element-627">
      <div data-id="element-628">
        <h1 className="text-white text-2xl font-bold mb-8 text-center" data-id="element-629">
          WhatsApp Work Order Capture
        </h1>
        <WhatsAppMockup data-id="element-630" />
        <p className="text-slate-400 text-center mt-4 text-sm" data-id="element-631">
          Screenshot this to use in Feature 2
        </p>
      </div>
    </div>;
};
export default WhatsAppPreview;